
import Vue from 'vue'
import { mapGetters } from 'vuex'
import RIcon from '@/components/icons/index.vue'
import RButton from '@/components/forms/RButton.vue'

export default Vue.extend({
  name: 'NotificationsContainer',
  components: {
    RIcon,
    RButton,
  },
  computed: {
    ...mapGetters({
      lastNotification: 'notification/lastNotification',
    }),
  },
  watch: {
    lastNotification(notification) {
      if (!notification) {
        return
      }
      //when logging out and reseting vuex undefind is passed so destructuring has to be conditional
      const { text, type } = notification
      this.$notify({
        group: 'notifications',
        title: text,
        duration: type === 'error' ? -1 : 3500,
        type,
      })
    },
  },
})
